








import {
    useVueRouter,
    useVuexStore,
} from '@superbet-group/web.lib.vue-utilities';
import {
    computed,
    defineComponent,
} from '@vue/composition-api';

import { slugify } from '@app/utils/slugify';
import SportCompetitions from '@sportOfferFederation/competitions/components/SportCompetitions.vue';
import { SportOfferDataStore } from '@store/modules/data/sportOffer';
import CompetitionEmptyState from '@sportOfferFederation/competitions/components/placeholders/CompetitionEmptyState.vue';

export default defineComponent({
    name: 'SportCompetitionsPage',
    setup() {
        const { route } = useVueRouter();

        const sportOfferStore = useVuexStore<SportOfferDataStore>('data/sportOffer');

        const sports = sportOfferStore.getter('sports');

        const sportId = computed(() => {
            return Object.values(sports.value)
                .find((sport) => slugify(sport.urlName) === route.value.params.sportSlug)
                ?.id;
        });

        return {
            sportId,
            isOfferReady: sportOfferStore.getter('isOfferReady'),
        };
    },
    components: {
        SportCompetitions,
        CompetitionEmptyState,
    },
});
